// Analytics — dataLayer vrstva + přeposlání eventů do GA4 (gtag), pokud je načtený.
export const trackEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (typeof window.gtag === "function") window.gtag("event", event, params);
};

export const getUtmParams = () => {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "gclid"];
  const out = {};
  keys.forEach((k) => {
    const v = p.get(k);
    if (v) out[k] = v;
  });
  // UTM si držíme v sessionStorage, aby přežily navigaci na jinou stránku před odesláním formuláře
  try {
    const stored = JSON.parse(sessionStorage.getItem("et_utm") || "{}");
    const merged = { ...stored, ...out };
    if (Object.keys(merged).length) sessionStorage.setItem("et_utm", JSON.stringify(merged));
    return merged;
  } catch {
    return out;
  }
};
